import { Box, Button, Center, Group, Stack, Text, useMantineTheme } from '@mantine/core';
import { IconCircleArrowUpFilled, IconSparkles } from '@tabler/icons-react';
import { AiSummaryBasePanel } from 'app/Private/Clients/Detail/InfoTab/components/AiSummaryPanel/AiSummaryBasePanel';
import { i18nKeys, useTranslation } from 'locales';
import { usePostHog } from 'posthog-js/react';
import { useParams } from 'react-router';
import { captureEvent } from 'shared/analytics/capture-event';
import { animatedGradientText, gradientBorderClass } from './AiSummaryPanel.styles';

export const AiSummaryUpsellPanel = () => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const posthog = usePostHog();

  const { id: debtorId } = useParams<{ id: string }>();

  const handleUpsell = () => {
    captureEvent(posthog, 'debtor:upsell_ai_context_provider_clicked', {
      debtor_id: debtorId,
    });
    window.Intercom('show');
  };

  return (
    <AiSummaryBasePanel
      title={
        <Group gap={6}>
          <IconSparkles color={theme.colors.purple[6]} size={18} stroke={1.5} />
          <Text className={animatedGradientText}>{t(i18nKeys.AI_SUMMARY.BILLING_PANEL.TITLE)}</Text>
        </Group>
      }
    >
      <Center h="100%">
        <Stack>
          <Text c="gray.10" fw={500}>
            {t(i18nKeys.AI_SUMMARY.BILLING_PANEL.DESCRIPTION)}
          </Text>
          <Box className={gradientBorderClass}>
            <Button
              variant="transparent"
              onClick={handleUpsell}
              c="white"
              rightSection={<IconCircleArrowUpFilled color="white" stroke={1.5} size={20} />}
              w="100%"
            >
              {t(i18nKeys.AI_SUMMARY.BILLING_PANEL.MORE_INFORMATION)}
            </Button>
          </Box>
        </Stack>
      </Center>
    </AiSummaryBasePanel>
  );
};
